module.exports = "<div class=\"assign-drvr-popup-wrapper\">\n\n  <lfwms-result-data-table \n  (buttonActionHandler)=\"handleButtonAction($event)\" \n [tableMode] = \"tableMode\"\n[searchService]=\"assignDriverSearchService\"\n[popupMode]=\"true\">\n</lfwms-result-data-table>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/wave-control-popups/assign-driver-popup/assign-driver-popup.component.html
// module id = ../../../../../src/app/shared/lookup/wave-control-popups/assign-driver-popup/assign-driver-popup.component.html
// module chunks = main